module.exports = __webpack_public_path__ + "static/media/cc_sdk_en.0149ef63.md";